// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana Process Types
 * Auto-generated input/output schemas for every Rana process tag. Do not edit manually.
 *
 * The version of the OpenAPI document: generated
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DefineStudyAreaInput } from "./DefineStudyAreaInput";
import {
  DefineStudyAreaInputFromJSON,
  DefineStudyAreaInputFromJSONTyped,
  DefineStudyAreaInputToJSON,
  DefineStudyAreaInputToJSONTyped,
} from "./DefineStudyAreaInput";
import type { DefineStudyAreaOutput } from "./DefineStudyAreaOutput";
import {
  DefineStudyAreaOutputFromJSON,
  DefineStudyAreaOutputFromJSONTyped,
  DefineStudyAreaOutputToJSON,
  DefineStudyAreaOutputToJSONTyped,
} from "./DefineStudyAreaOutput";

/**
 *
 * @export
 * @interface DefineStudyAreaSchema
 */
export interface DefineStudyAreaSchema {
  /**
   *
   */
  tag: DefineStudyAreaSchemaTagEnum;
  /**
   *
   */
  inputs: DefineStudyAreaInput;
  /**
   *
   */
  outputs: DefineStudyAreaOutput;
}

/**
 * @export
 */
export const DefineStudyAreaSchemaTagEnum = {
  DefineStudyArea: "define_study_area",
} as const;
export type DefineStudyAreaSchemaTagEnum =
  (typeof DefineStudyAreaSchemaTagEnum)[keyof typeof DefineStudyAreaSchemaTagEnum];

/**
 * Check if a given object implements the DefineStudyAreaSchema interface.
 */
export function instanceOfDefineStudyAreaSchema(value: object): value is DefineStudyAreaSchema {
  if (!("tag" in value) || value["tag"] === undefined) return false;
  if (value["tag"] !== "define_study_area") return false;

  if (!("inputs" in value) || value["inputs"] === undefined) return false;
  if (!("outputs" in value) || value["outputs"] === undefined) return false;
  return true;
}

export function DefineStudyAreaSchemaFromJSON(json: any): DefineStudyAreaSchema {
  return DefineStudyAreaSchemaFromJSONTyped(json, false);
}

export function DefineStudyAreaSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DefineStudyAreaSchema {
  if (json == null) {
    return json;
  }
  return {
    tag: json["tag"],
    inputs: DefineStudyAreaInputFromJSON(json["inputs"]),
    outputs: DefineStudyAreaOutputFromJSON(json["outputs"]),
  };
}

export function DefineStudyAreaSchemaToJSON(json: any): DefineStudyAreaSchema {
  return DefineStudyAreaSchemaToJSONTyped(json, false);
}

export function DefineStudyAreaSchemaToJSONTyped(
  value?: DefineStudyAreaSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    tag: value["tag"],
    inputs: DefineStudyAreaInputToJSON(value["inputs"]),
    outputs: DefineStudyAreaOutputToJSON(value["outputs"]),
  };
}
